import dayjs from 'dayjs';

import { eVisitFrontDoorNewInsuranceScreen } from 'lib/triage/constants';
import { Color } from 'modules/styles/colors';
import { AppName, getAppName } from 'modules/utils/ConfigUtils';
import { NavigationRoutesConfigMap } from 'navigation/types';
import { eVisitSLASelector } from 'store/eVisit/selectors';
import { SLA } from 'store/eVisit/types';
import { profileConsumerDisplayNameSelector, profilePhonesSelector } from 'store/profile/selectors';
import { RootState } from 'store/types';

export const buildEVisitData = (state: RootState, selectedLocationState: string) => {
  const eVisitSLA = eVisitSLASelector(state).find((i: SLA) => i.state === selectedLocationState);

  // Compose Form Data
  const signedBy = profileConsumerDisplayNameSelector(state);
  const signedDate = dayjs().format('MM/DD/YYYY HH:mm:ss');
  const relationshipToPatient = 'PATIENT';
  const phoneNumber = profilePhonesSelector(state)?.[0]?.value;
  const eVisitData = {
    forms: [
      {
        docName: 'NoticeofPrivacy',
        docAliasId: '50086a',
        witness: `Sign By ${getAppName(AppName.secondary, 'the')}`,
        signedBy,
        signedDate,
        relationshipToPatient,
        phoneNumber
      },
      {
        docName: 'ConsentandConditionsofService',
        docAliasId: '50064',
        witness: `Sign By ${getAppName(AppName.secondary, 'the')}`,
        signedBy,
        signedDate,
        relationshipToPatient,
        phoneNumber
      }
    ],
    sla: eVisitSLA
  };

  return eVisitData;
};

export const getCurrentEVisitStep = (currentScreen: string, screens: NavigationRoutesConfigMap) => {
  const screenIndex = Object.keys(screens).findIndex(key => key === currentScreen);
  return screenIndex ? screenIndex + 1 : 1;
};

export const getUploadStatusInfo = (status?: string) => {
  const { sectionCards } = eVisitFrontDoorNewInsuranceScreen;
  switch (status) {
    case 'processing':
      return {
        title: sectionCards.processingTitle,
        description: sectionCards.processingDescription,
        titleColor: Color.primary,
        descriptionColor: Color.primary
      };
    case 'success':
      return {
        title: sectionCards.successTitle,
        description: sectionCards.successDescription,
        titleColor: Color.darkGreenShade,
        descriptionColor: Color.secondary,
        icon: 'Success'
      };
    case 'error':
      return {
        title: sectionCards.errorTitle,
        description: sectionCards.errorDescription,
        titleColor: Color.alertError,
        descriptionColor: Color.alertError,
        icon: 'Error'
      };
    default:
      return {
        title: sectionCards.cardTitle,
        description: sectionCards.cardDescription,
        titleColor: Color.secondary,
        descriptionColor: Color.secondary
      };
  }
};
